<app-dialog-header
  (close)="close.emit('')"
  [description]="description"
  [hideCloser]="hideCloser"
  >{{ title }}</app-dialog-header
>
<mat-dialog-content>
  <ng-content></ng-content>
</mat-dialog-content>
<app-dialog-footer
  *ngIf="actions && actions.length"
  [actions]="actions"
  (action)="emitAction($event)"
></app-dialog-footer>
